import { MENU_LAYOUT_ID } from 'bento-ordering/menus/layouts/MenuLayout';
import { ORDER_SETTINGS_ID } from 'bento-ordering/menus/layouts/OrderSettingsLayout';
import { CART_LAYOUT_ID } from 'bento-ordering/cart/layouts/CartPageLayout';

/**
 * Menu page relies on the size of the viewport to
 * deteremine how the menu section bar should be rendered. There
 * are three different layouts that can be rendered with the menu,
 * (menu, order settings, cart). The layout will be rendered base
 * on the component that is rendered.
 */
export const getMenuViewportReference = () => {
  return (
    document.getElementById(MENU_LAYOUT_ID) ||
    document.getElementById(ORDER_SETTINGS_ID) ||
    document.getElementById(CART_LAYOUT_ID)
  );
};
